import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PhoneField from 'components/v2/forms/PhoneField';
import { withTranslation } from 'react-i18next';
import DeleteButton from 'components/v2/buttons/DeleteButton';
class ContactField extends Component {
    constructor() {
        super(...arguments);
        this.handleNameChange = (e) => this.props.onChange('name', e.target.value);
        this.handleEmailChange = (e) => this.props.onChange('email', e.target.value);
        this.handlePhoneChange = (number) => this.props.onChange('phone', number);
        this.handleRemove = () => this.props.onRemove();
    }
    render() {
        const { id, contact: { name, email, phone }, t, } = this.props;
        return (React.createElement("div", { className: "flex flex-wrap items-center -mx-2" },
            React.createElement("div", { className: "md:w-1/4 w-full px-2" },
                React.createElement("fieldset", { className: "" },
                    React.createElement("input", { className: "form-field block mb-4 md:mb-0 w-full", value: name, placeholder: t('CONTACTS_NAME'), onChange: this.handleNameChange }))),
            React.createElement("div", { className: "md:w-1/4 w-full px-2" },
                React.createElement("fieldset", { className: "" },
                    React.createElement("input", { type: "email", className: "form-field block mb-4 md:mb-0 w-full", value: email, placeholder: t('CONTACTS_EMAIL'), onChange: this.handleEmailChange }))),
            React.createElement("div", { className: "md:w-1/4 w-full px-2" },
                React.createElement(PhoneField, { value: phone, id: id, onChange: this.handlePhoneChange, className: "md:mb-0 mb-4" })),
            React.createElement("div", { className: "flex-1 px-2" },
                React.createElement(DeleteButton, { onClick: this.handleRemove }))));
    }
}
ContactField.propTypes = {
    contact: PropTypes.shape({
        name: PropTypes.string,
        value: PropTypes.string,
    }),
    onChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
};
export default withTranslation()(ContactField);
